module.exports = __webpack_public_path__ + "static/img/1x2_popup_margin_pc.1e57c45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/1x2_popup_margin_pc.png
// module id = iX5C
// module chunks = 1